

import React from 'react';

import {Upload, Button } from '@jd/find-react';

 

import KeeVue from '../base/KeeVue.js'

 

import $ from 'jquery';

import FsList from './FsList.js';
import FeasPage from '../render/FeasPage.js'


export default class FsBuildPages extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				randId: this.getRandString(),
				activeRightTab: 'r3',
				keeVueComponents: [],
				appPages: [],
				activePageList: [],
				formField: null,
				newPageIds: [],
				formTypes: [],
				downloadPath: '',
				downloadName: '',
				appId: window.appId,
				isShowExport: false,
				initSelectPageCode: '',
			};

}

componentDidMount(){
			let that = this;
			 this.onEvent("drag", this.onDrag);
			 this.onEvent("draging", this.onDraging);
			 this.onEvent("droped", this.onDroped);
			this.onEvent("top.save", this.onTopSave);
			this.onEvent("top.preview",this.onTopPreview);
			this.onEvent("top.publishApp", this.onPublishApp);
			this.onEvent("exchanged", this.onExchanged);
			this.loadKeePageList();
			this.onEvent("createNewPageByPage",this.onCreateNewPageByPage);
			
			this.onEvent("socketCreateNewPage",this.onSocketCreateNewPage);
			
			
			this.onEvent("changePageType",()=>{
				this.refresh();
			})
			
			this.onEvent("exportApp",this.onExportPages);
			
			this.onEvent("socketMessage",this.onSocketMessage);
			
			this.onEvent("socketRemoveAppPage",this.removeSocketAppPage);
			
			this.onEvent("importApp",()=>{
				that.openDlgPage("M::jdccApp/importPagesZip"  , {
					title: '导入应用',
					size: '800',
					 
					top: "10vh",
					loadUrl: '/jdccApp/get?id=' ,
					extraParas: { 
						appId: this.props.appid, 
					},
					onChanged:(ret, form)=> {
						
						if(ret&&ret.success)
						{
							this.state.appPages = [];
							this.state.activePageList = [];
							window.appPages = this.state.appPages; 
							this.loadKeePageList(); 
							this.showMessage("导入操作成功"); 
							this.sendEvent("pageSaved");
							this.refresh();
							
							form.$emit("changed");
						}
						else
						{
							this.showMessage(ret);
						}
						 
					}
				})
			})
			 
			this.onEvent("setPage",this.setPageState);
			
			// this.onEvent("addComponent",this.onAddComponent);
			
			// this.onEvent("deleteComponent",()=>{alert("deleteComponent")});
			
			// this.onEvent("chongzuo",this.chongzuoState);
			
		}
		
		 onSocketMessage=(json)=>{
		 	
		 	// 收到socket服务器发来的消息
		 	
		 	// let pageInitInfo = {
		 	// 	appId:this.keePage.appId,
		 	// 	fromEditor:window.editorInfo,
		 	// 	keePage:this.keePage,
		 	// 	components:this.components
		 	// }
		 	
		 	if(json==this.socketPageJson)
		 	{
		 		return ;
		 	}
		 	
		 	// 防止形成死循环
		 	this.socketPageJson = json;
		 	 
		 	let pageInitInfo = JSON.parse(json); 
		 	
		 	if(pageInitInfo.fromEditor==window.editorInfo)
		 	{
		 		// 自己发的，也不处理
		 		console.log("自己发送到消息，不处理")
		 		return;
		 	}
		 	
		 	// 如果是当前页面，则进行更新
			let currentPageId = "";
			for(let i = 0; i < this.state.activePageList.length; i++) {
				if(this.state.activePageList[i].isSelected) { 
					currentPageId = this.state.activePageList[i].id ; 
				}  
			}
			
		 	
		 	if(pageInitInfo.keePage.id==currentPageId)
		 	{  
		 		for(let i=0;i<window.activePageList.length;i++)
		 		{
		 			if(window.activePageList[i].id==pageInitInfo.keePage.id)
		 			{
		 				window.activePageList[i].keePage = pageInitInfo.keePage;
		 			}
		 		}
		 		
		 		// 如果有选中组件和没有选中的组件，
		 		// let selectYuanComponent = null;
		 		// if(this.state.activeComponent)
		 		// {
		 		// 	selectYuanComponent = this.getComponentById(this.state.activeComponent.id,pageInitInfo.keePage.components);
		 		// }  
		 		// this.setActiveComponent(selectYuanComponent);
		 		
		 		// this.vueApp.showPage(pageInitInfo.keePage.components, pageInitInfo.keePage);
		 		
		 		
				this.editApp(pageInitInfo.keePage);
		 		
		 		this.currentVueSource = pageInitInfo.keePage.vueSource;
				
				window.socketVueSource = pageInitInfo.keePage.vueSource;
		 		
		 		if(window.editor.getValue()!=pageInitInfo.keePage.vueSource)
		 		{
		 			window.editor.setValue(pageInitInfo.keePage.vueSource);
		 		}
		 		
		 		this.refresh();
		 		
		 	}
		 	else
		 	{
		 		//非当前页面，需要更新一下！ 
		 		if(window.activePageList)
		 		{
		 			for(let i=0;i<window.activePageList.length;i++)
		 			{
		 				if(window.activePageList[i].id==pageInitInfo.keePage.id)
		 				{
		 					window.activePageList[i].keePage = pageInitInfo.keePage;
		 				}
		 			}
		 		} 
		 	} 
		 }
			
			findFormItems = (components,formItems,fieldItems)=>{
				let hasRequireField = false;
				components.map((item)=>{
					
					//console.log("====",item);
					
					if(item.type=='form'&&item.name!='fs-text')
					{
						formItems.push(item);
						
						let fieldItem = {};
						
						fieldItem.fieldId = this.getRandString(); 
						fieldItem.name = (item.cp.field?item.cp.field:item.alias);
						fieldItem.comment = (item.cp.title?item.cp.title:'标题'); 
						fieldItem.isKey = "";
						fieldItem.type = "VARCHAR"
						fieldItem.length = 200;
						fieldItem.decLength = ""; 
						fieldItem.isNotNull = "";
						
						if(item.cp.required)
						{
							hasRequireField = true;
						}
					 
						fieldItems.push(fieldItem);
						// {
						// 	"fieldId": "2021080309344486913413571430-CSY",
						// 	"isKey": "",
						// 	"name": "danwei",
						// 	"type": "VARCHAR",
						// 	"length": 48,
						// 	"decLength": "",
						// 	"isNotNull": "",
						// 	"comment": "单位"
						// },
						
					}
					
					if(item.child&&item.child.length>0)
					{
						let ret =  this.findFormItems(item.child,formItems,fieldItems);
						
						if(ret)
						{
							hasRequireField = ret;
						}
					}
				})
				
				return hasRequireField;
				
			}
			
			createNewCol=(table0,formItems,callback)=> {
				
				//alert(JSON.stringify(formItems));
				
				let that = this;
				let component = table0;
				this.doRequest("/keeVueComponent/getByName?name=fs-table-col", (ret)=> {
					if(ret !== null && ret.id !== null) {
						
						
						this.doRequest("/keeVueApp/getAppConfig?title=fs-table-col-prop-form&name=form", (data)=> {
							
							 
							
							formItems.map((addComponent)=>{
								let c = $.extend({
									style: $.extend({}, {
										display: 'block',
									}),
									cp: {
										field: (addComponent.cp.field?addComponent.cp.field:addComponent.alias) ,
										title:(addComponent.cp.title?addComponent.cp.title:'标题')
									},
									alias: this.getRandString(), // 别名
									value: ''
								}, ret, {
									id: this.getRandString(),
									rect: {
										x: 0,
										y: 0,
										w: 0,
										h: 0,
									},
									child: [], // 这个很重要，必须要，否则检测不到变化
								});
								c.isSelected = false;
								c.isKeeShowBorder = false;
								that.initComponentByFormField(c, data);
								
								
								
								
								component.child.push(c);
							})
							
							callback();
							
							
							 
						});
					}
			
				});
			}
			

			changeRightTab=(tab)=> {
				this.state.activeRightTab = tab.name;
			}
			createNewComponent=(name)=> {
				let currentComponent = this.getVueComponent(name);
				let x = 0;
				let y = 0;
				let w = parseInt($('#designContentDiv').width());
				let h = parseInt($('#designContentDiv').height());
				let X = 0;
				let Y = 0;
				if(currentComponent ) {
					let that = this;
					let c = null;
					let display = "block";
					if(currentComponent.name == 'fs-text' || currentComponent.name == 'fs-drop' || currentComponent.name == 'el-button') {
						display = "inline-block";
					}
					if(currentComponent.name == 'kee-div') {
						c = $.extend({
							style: $.extend({}, that.moveDivStyle, {
								display: display,
								left: X - x - that.moveDivStyle.width / 2 - 1,
								top: Y - y - that.moveDivStyle.height / 2 - 1,
								position: 'absolute',
							}),
							alias: this.getRandString(), // 别名
							cp: {},
							value: ''
						}, currentComponent, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
					} else {
						c = $.extend({
							style: $.extend({}, {
								display: display,
							}),
							cp: {},
							alias: this.getRandString(), // 别名
							value: ''
						}, currentComponent, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
					}
					let name = currentComponent.name;
					c.isKeeShowBorder = false;
					c.isSelected = true;
					c.isMoving = true;
					c.isAdding = true; // 设置正在添加为true
					currentComponent = null;
					return c;
				}
			}
			getVueComponent=(name)=> {
				for(let n = 0; n < this.state.keeVueComponents.length; n++) {
					if(this.state.keeVueComponents[n].name == name) {
						return this.state.keeVueComponents[n];
					}
				}
			}
			convertFeasForm=(fields, title)=> {

				alert("converFeasForm");
				let that = this;
				console.log("开始处理----------------------------：")
				this.doRequest("/keePage/get", (ret)=> {
					that.state.newPageIds.push(ret.id);
					let newPage = that.initKeePage({
						id: ret.id,
						isDel: false,
						code: title + "-prop-form",
						type: 'M',
						url: '',
						title: title + '属性页面',
						isCanEdit: false,
					}, that.state.formField);
					newPage.id = ret.id;
					let cps = newPage.keePage.components;
					let fsform = that.createNewComponent("fs-form");
					console.log(fsform.name);
					for(let i = 0; i < fields.length; i++) {
						let field = fields[i];
						if(field.type == 'block')
							continue;
						let fsRow = that.createNewComponent("el-row");
						let newComp = null;
						let exists = false;
						for(let m = 0; m < that.state.formTypes.length; m++) {
							if(that.state.formTypes[m] == field.type) {
								exists = true;
							}
						}
						if(!exists) {
							that.state.formTypes.push(field.type);
						}
						console.log("类型：" + field.type);
						if(title == 'el-button')
							return;
						if(field.field == 'cp.showExpression')
							continue;
						if(field.field == '')
							continue;
						if(field.type == 'block')
							continue;
						if(field.type == 'text') {
							newComp = that.createNewComponent("fs-input");
						}
						if(field.type == 'textarea') {
							newComp = that.createNewComponent("fs-textarea");
						}
						if(field.type == 'switch') {
							newComp = that.createNewComponent("fs-switch");
						}
						if(field.type == 'select') {
							newComp = that.createNewComponent("fs-select");
						}
						if(field.type == 'radio') {
							newComp = that.createNewComponent("fs-radio");
						}
						if(field.type == 'filter') {
						}
						if(field.type == 'icon') {
							newComp = that.createNewComponent("fs-icon");
						}
						if(field.type == 'img') {
							newComp = that.createNewComponent("fs-img");
						}
						if(newComp == null)
							continue;
						newComp.cp.title = field.title;
						newComp.cp.labelWidth = 70;
						newComp.cp.defaultValue = field.map.defaultValue;
						newComp.cp.field = field.field;
						newComp.cp.dsType = field.map.dsType;
						newComp.cp.listOptions = field.map.listOptions;
						newComp.cp.dict = field.map.dict;
						newComp.cp.url = field.map.url;
						if(!this.isNotBlank(newComp.cp.title)) {
							newComp.cp.title = newComp.cp.field;
						}
						if(newComp ) {
							fsRow.child.push(newComp);
							fsform.child.push(fsRow);
						}
					}
					this.doRequest("/keeVueApp/listData?search_LIKE_title=" + title + "-field-form&fields=jsonString,title", (ret)=> {
						for(let n = 0; n < ret.rows.length; n++) {
							let fields2 = JSON.parse(ret.rows[n].jsonString).fields;
							for(let i = 0; i < fields2.length; i++) {
								let field2 = fields2[i];
								if(field2.type != 'block') {
									if(field2.field == '')
										continue;
									let fsRow2 = that.createNewComponent("el-row");
									let newComp2 = null;
									let exists = false;
									for(let m = 0; m < that.state.formTypes.length; m++) {
										if(that.state.formTypes[m] == field2.type) {
											exists = true;
										}
									}
									if(!exists) {
										that.state.formTypes.push(field2.type);
									}
									 
									if(field2.field == 'cp.showExpression')
										continue
									if(field2.field == 'noname')
										continue
									if(field2.type == 'text' || field2.type == "dict") {
										newComp2 = that.createNewComponent("fs-input");
									}
									if(field2.type == 'textarea' || field2.type == "jsonList") {
										newComp2 = that.createNewComponent("fs-textarea");
									}
									if(field2.type == 'switch') {
										newComp2 = that.createNewComponent("fs-switch");
									}
									if(field2.type == 'select') {
										newComp2 = that.createNewComponent("fs-select");
									}
									if(field2.type == 'radio') {
										newComp2 = that.createNewComponent("fs-radio");
									}
									if(field2.type == 'filter') {
									}
									if(field2.type == 'icon') {
										newComp2 = that.createNewComponent("fs-icon");
									}
									if(field2.type == 'img') {
										newComp2 = that.createNewComponent("fs-img");
									}
									if(newComp2 == null)
										continue;
									if(title == 'fs-input') {
										console.log("==============================" + field2.type)
									}
									newComp2.cp.title = field2.title;
									newComp2.cp.labelWidth = 70;
									newComp2.cp.defaultValue = field2.map.defaultValue;
									newComp2.cp.field = field2.field;
									newComp2.cp.dsType = field2.map.dsType;
									newComp2.cp.listOptions = field2.map.listOptions;
									newComp2.cp.dict = field2.map.dict;
									newComp2.cp.url = field2.map.url;
									if(!this.isNotBlank(newComp2.cp.title)) {
										newComp2.cp.title = newComp2.cp.field;
									}
									if(newComp2  && field2.type != 'block') {
										fsRow2.child.push(newComp2);
										fsform.child.push(fsRow2);
									}
								}
							}
						}
						cps.push(fsform);
						that.state.activePageList.push(newPage);
						that.state.appPages.push(newPage);
					})
				});
			}
			batchConver=()=> {
				let that = this;
				this.doRequest("/keeVueApp/listData?search_LIKE_title=-prop-form&fields=jsonString,title", (ret)=> {
					for(let i = 0; i < ret.rows.length; i++) {
						let fields = JSON.parse(ret.rows[i].jsonString).fields;
						console.log(ret.rows[i].title);
						let exists = false;
						let componentTitle = "";
						for(let j = 0; j < that.state.keeVueComponents.length; j++) {
							if(ret.rows[i].title.indexOf(that.state.keeVueComponents[j].name + "-prop-form") != -1) {
								componentTitle = that.state.keeVueComponents[j].name;
								exists = true;
							}
						}
						if(exists == true && fields ) {
							that.convertFeasForm(fields, componentTitle);
						}
						if(ret.rows[i].title.indexOf("common-component-") != -1) {
							that.convertFeasForm(fields, "common-component");
						}
						console.log("处理完一个！" + exists + (fields ))
					}
				})
			}
			testLog=()=> {
				console.log(JSON.stringify(this.state.appPages));
			}
			onImportPages=()=> {
			}
			onImportSuccess=(uploadFile)=> {
				// {
//   file: { /* ... */ },
//   fileList: [ /* ... */ ],
//   event: { /* ... */ },
// }
// 				// file:{
				//    uid: 'uid',      // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
				//    name: 'xx.png'   // 文件名
				//    status: 'done', // 状态有：uploading done error removed
				//    response: '{"status": "success"}', // 服务端响应内容
				//    linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
				// }
				console.log("文件状态:"+JSON.stringify(uploadFile));
				if(uploadFile.file.status=='done')
				{
					this.state.appPages = [];
					this.state.activePageList = [];
					window.appPages = this.state.appPages;
					
					this.loadKeePageList();
					uploadFile.fileList.splice(0,uploadFile.fileList.length);
					this.showMessage("导入操作成功");
					this.state.isShowExport=false;
					this.refresh();
				}
				
				
			}
			
			removeNotUserProperty=(componentArray)=>{
				for(let i=0;i<componentArray.length;i++)
				{
					delete componentArray[i].functions;
					delete componentArray[i].icon;
					delete componentArray[i].rect;
					delete componentArray[i].events;
					delete componentArray[i].isKeeShowBorder;
						
					delete componentArray[i].isSelected;
					delete componentArray[i].isMoving;
					delete componentArray[i].showChild;
					
					delete componentArray[i].children;
					delete componentArray[i].sysUser;
					delete componentArray[i].sysOrg;
					 
					
					
					if(componentArray[i].style)
					{
						for(let p in  componentArray[i].style)
						{
							if(componentArray[i].style[p]===null||componentArray[i].style[p]==="")
							{
								delete componentArray[i].style[p];
							}
						}
					} 
					if(componentArray[i].child)
					{
						this.removeNotUserProperty(componentArray[i].child);
					}
					
				}
			}
			
			removePageProperty=(componentArray)=>{
				for(let i=0;i<componentArray.length;i++)
				{
					this.removeNotUserProperty(componentArray[i].keePage.components);
				}
				
			}
			
			onExportPages=()=> {
				let count = 0;
				let that = this;
				if(this.isNotBlank(this.state.appId)) {
					
					
					
					
					this.doRequest("/jdccApp/get?id=" + this.state.appId,  (jdccApp)=> {
						let toSubmitPages = JSON.parse(JSON.stringify(that.state.appPages));
						if(toSubmitPages ) {
							for(let i = 0; i < toSubmitPages.length; i++) {
								toSubmitPages[i].keePage.pageXmlConfig = "";
								toSubmitPages[i].keePage.sqlTemplate = "";
							}
						}
						
						that.removePageProperty(toSubmitPages)
					 
						this.doRequest("/keePage/exportPagesWithZip", (ret)=> {
							if(ret.success == true) {
								
								this.state.appPages = [];
								this.state.activePageList = [];
								window.appPages = this.state.appPages; 
								this.loadKeePageList();  
								this.sendEvent("pageSaved");
								this.refresh();
								
								this.showMessage("应用配置保存并导出成功！");
								that.state.downloadName = jdccApp.title + "(" + jdccApp.name + ")_" + this.formatterDate(new Date(), "yyyyMMdd_hhmmss") + ".zip";
								window.$.fileDownload(window.fileUrl+"/api/fs/download?path=" + ret.message + "&filename=" + that.state.downloadName   + "&tid=" + window.tid);
							 
							}
							else
							{
								that.showMessage(ret);
							}
						}, {
							appPages: JSON.stringify( toSubmitPages ),
							appId: window.appId,
							tid: window.tid
						});
					})
				} else {
					alert("应用编号为空，暂不支持导出")
				}
			}
			showEditModal=(row)=> {
				this.sendEvent("drag.stop");
				for(let i = 0; i < this.state.appPages.length; i++) {
					if(row.keePage.id == this.state.appPages[i].keePage.id) {
						row.keePage.isCanEdit = true;
					} else {
						this.state.appPages[i].keePage.isCanEdit = false;
					}
				}
			}
			onBlur=(row)=> {
				row.keePage.isCanEdit = false;
				this.sendEvent("drag.start");
			}
			editAppPage=(row)=> {
				this.sendEvent("right.showPageConfig", row, this.state.appPages);
			}
			onExchanged=(item)=> {
				this.removeAppPage(item);
				this.state.appPages.remove(item);
			}
			
			onPublishApp=()=> {
				let newPages = [];
				let that = this;
				window.showMessage("同步应用版本数据...");
				this.doRequest("/keePage/listData?search_EQ_appId=" + window.appId + "&order=asc&sort=seq&fields=code,title,type,url,pageXmlConfig,sqlTemplate,config,isDel,updateTime", function(ret) {
						if(ret.rows != null) {
						 for(let i = 0; i < ret.rows.length; i++) {
							ret.rows[i].components = JSON.parse(ret.rows[i].pageXmlConfig);
				            ret.rows[i].pageXmlConfig = "";
				             ret.rows[i].config = JSON.parse(ret.rows[i].config);
				             ret.rows[i].vueSource = ret.rows[i].sqlTemplate;
				             ret.rows[i].sqlTemplate="";
				            newPages.push({keePage:ret.rows[i],
								 id:ret.rows[i].id,
								 code:ret.rows[i].code,
							 }); 	
							}
						}
											
						that.openDlgPage("M::jdccApp/publishForm"  , {
				    					title: '存档到应用市场',
				    					size: '900',
				    					 
				    					top: "10vh",
				    					loadUrl: '/jdccApp/get?id=' ,
				    					extraParas: {
				    						isRelease: false,
				    						id: window.appId,
				    						appPages: JSON.stringify(newPages),
				    					},
				    
				    					onChanged:  (ret, form)=> {
				    						this.showMessage(ret);  
				    						//触发这个事件，让系统关闭对话框
				    						form.$emit("command", "close"); 
				    					}
				    		});
				});
			}
			
				    	
			
			onPublishApp2=()=> {
				let that = this;
				
				//提醒是否要继续发布??
				
				//需要同步一下最新的数据，看看有没有哪个页面时没有值 
				let existsBlankPage = false; 
				for(let i=0;i<that.state.appPages.length;i++)
				{
					let appPage = that.state.appPages[i];
					if(!appPage.keePage||!appPage.keePage.pageXmlConfig)
					{
						if(!appPage.loading)
						{
							appPage.loading=true;
							this.doRequest("/keePage/getPageJson?id="+appPage.id,(ret)=>{  
								//判断是redis里面的还是db返回的 
								if(ret)
								{
									if(ret.keePage)
									{ 
										appPage.keePage = ret.keePage;
										appPage.code = ret.keePage.code; 
									}
									else
									{
										if(ret.pageXmlConfig)
										{
											appPage.keePage.pageXmlConfig = ret.pageXmlConfig;
											appPage.keePage.sqlTemplate = ret.sqlTemplate; 
											let newAppPage = this.initKeePage(ret,this.state.formField);
											appPage.keePage = newAppPage.keePage;
											appPage.code = newAppPage.code; 
										} 
									} 
								}
								else
								{ 
									 alert("加载页面失败！");
								} 
							})
						} 
					}
				}
				for(let i=0;i<that.state.appPages.length;i++)
				{
					let appPage = that.state.appPages[i];
					if(!appPage.keePage||(typeof appPage.keePage.components=="undefined"))
					{
						setTimeout(()=>{
							console.log("有空页面，请确认");
							this.onPublishApp(); 
						},100);
						return ;
					}
				}
				 
				let toSubmitPages = JSON.parse(JSON.stringify(that.state.appPages));
				if(toSubmitPages ) {
					for(let i = 0; i < toSubmitPages.length; i++) {
						toSubmitPages[i].keePage.pageXmlConfig = "";
						toSubmitPages[i].keePage.sqlTemplate = "";
					}
				}
				if(toSubmitPages==null||toSubmitPages.length==0)
				{
					alert("不能保存空页面的应用，至少需要创建一个页面!");
					return ;
				}
				that.openDlgPage("M::jdccApp/publishForm"  , {
					title: '存档到应用市场',
					size: '900', 
					top: "10vh",
					loadUrl: '/jdccApp/get?id=' ,
					extraParas: {
						isRelease: false,
						id: this.props.appid,
						appPages: JSON.stringify(toSubmitPages),
					},
					onChanged(ret, form) {
						that.showMessage(ret);
						form.$emit("command", "close");
					}
				})
			}
			getAllComponentName=(componentArray,useNames)=>
			{
				if(componentArray!=null)
				for(let i=0;i<componentArray.length;i++)
				{
					useNames[componentArray[i].name] = true;
					if(componentArray[i].child!=null)
					{
						this.getAllComponentName(componentArray[i].child,useNames)
					}
				}
			}
			onTopPreview=(code,showReact,appId)=>{
				
				
				let token = window.getCookie(window.keyName + "_token");
					
					
				
					let count = 0;
					let that = this;
					let toSubmitPages = JSON.parse(JSON.stringify(that.state.appPages));
					let userNames = {};
					for(let m = 0; m< toSubmitPages.length; m++) {
						this.getAllComponentName(toSubmitPages[m].keePage.components,userNames);
					}
					console.log("关联组件："+JSON.stringify(userNames));
					
					// 要删除不需要的属性
					
					if(toSubmitPages ) {
						for(let i = 0; i < toSubmitPages.length; i++) {
							toSubmitPages[i].keePage.pageXmlConfig = "";
							toSubmitPages[i].keePage.sqlTemplate = "";
						}
					}
					if(toSubmitPages==null||toSubmitPages.length==0)
					{
						alert("不能保存空页面的应用，至少需要创建一个页面!");
						return ;
					}
					  let keyName = window.keyName; 
				 
				 let fromKeyName = this.getQueryVariable("keyName");
				 
				 let urlToken = this.getQueryVariable(keyName + "_token");
				 if(fromKeyName&&urlToken)
				 { 
				 	token = urlToken;
				 }
				 
				 
					
					this.removePageProperty(toSubmitPages)
					this.doRequest("/keePage/saveAppPagesToCache", (ret)=> {
					 
					 
					 
						if(ret.success == true) {
							
							if(window.isReport)
							{
								
								let url =window.location.protocol+"//"+window.location.host + "/index.html?sp=2021_M::jzbForm/show&appCode="+window.appName+"&fullPage=1&isPreview=1&_t="+this.getRandString();
							//alert(url);	
								// 看是手机还是pC端的预览
								//alert(window.pageType);
								if(window.pageType=='mobile')
								{
									url =window.location.protocol+"//"+window.location.host + "/h5.html?sp=2021_M::jzbForm/show&appCode="+window.appName+"&fullPage=1&isPreview=1";
									
									url+="&mobile=true";
									
									this.state.configWindow2 = window.open( url, window.appName + "H5" );
										
									this.state.configWindow2.location.reload(true);
								}
								else
								{
									this.state.configWindow2 = window.open( url, window.appName + "预览");
										
									this.state.configWindow2.location.reload(true);
								}
								 
								
							}
							else if(window.isActivity){
								console.log("do nothing");
							}
							else
							{
							
								let isShowReact = (showReact?'1':'');
								
								let clientType="";
								
								if(window.currentAppInfo&&window.currentAppInfo.clientType )
								{
									clientType="&clientType="+window.currentAppInfo.clientType;
								}
								//debugger; 
								
								this.state.configWindow = window.open(("/index.html?sp=2018_M::"+window.appName+"/"+code+"&tid=" + window.tid  +clientType+ "&isPreview=true&showReact="+isShowReact+"&keyName="+window.keyName+"&pageCode=" +  code+"&appName="+window.appName+"&_t="+this.getRandString() +"#preview"), window.appName + "预览");
								
								if(this.state.configWindow )
								{
									this.state.configWindow.location.reload(true);
								}
								 
							}
							
							
						}
					}, { 
						"_base":1,
						appPages:window.Base64.encode( JSON.stringify(toSubmitPages)),
						appId: (appId?appId:( window.appName+token))
					});
				 
			}
			onTopSave=()=> {
				let count = 0;
				let that = this;
				let toSubmitPages = JSON.parse(JSON.stringify(that.state.appPages));
				
				// 这个列表不包含删除的页面，导致页面删除失败
				// let toSubmitPages = JSON.parse(JSON.stringify(that.state.activePageList));
				let userNames = {};
				for(let m = 0; m< toSubmitPages.length; m++) {
				 
					if(window.currentAppInfo&&window.currentAppInfo.map)
					{
						let jsonConfig = JSON.stringify(toSubmitPages[m].keePage.config);
						toSubmitPages[m].keePage.config.resFileList = window.currentAppInfo.map.resFileList;
						toSubmitPages[m].keePage.config.appPageCss = window.currentAppInfo.map.appPageCss;
						let jsonConfigNew = JSON.stringify(toSubmitPages[m].keePage.config);
						
						if(jsonConfig!=jsonConfigNew)
						{
							toSubmitPages[m].keePage.edited = "1";
						} 
					}
					
					this.getAllComponentName(toSubmitPages[m].keePage.components,userNames);
				}
				console.log("关联组件："+JSON.stringify(userNames));
				
				// 要删除不需要的属性
				
				if(toSubmitPages ) {
					for(let i = 0; i < toSubmitPages.length; i++) {
						toSubmitPages[i].keePage.pageXmlConfig = "";
						toSubmitPages[i].keePage.sqlTemplate = "";
					}
				}
				if(toSubmitPages==null||toSubmitPages.length==0)
				{
					alert("不能保存空页面的应用，至少需要创建一个页面!");
					return ;
				}
				
				// 如果是报表应用，需要增加更新数据库表结构和数据库汇总列表的接口
				
				// 请求一下服务的列表刷新的问题
				this.doRequest("/serverInfo/refresh");
				 
				if(window.isReport )
				{
					let formItems = [];
					let components = toSubmitPages[0].keePage.components;
					 
					
					let compDescription = this.getComponentByAlias(components,"fsText002");
					let compName=this.getComponentByAlias(components,"fsText001");
					 
					
							// 调用后续的
							
					
					
					
					// 保存表单的名字和备注，另外还要统统不更新应用的名字
					
					
					
					// 保存数据库表结构，变更表；
					
					// 要判断版本，避免冲突，因为需要操作的接口比较多
					
					let tableName = window.appName;
										
					 this.doRequest("/lingLongModel/listData?search_EQ_name="+tableName,
									 (ret)=> {
					                
					                    if(ret&&ret.rows&&ret.rows.length>0)
					                    {
					                        let row = ret.rows[0];
					                        
					                        this.doRequest("/lingLongModel/get?id="+row.id,
									         (ret2)=> {
												 
												 let fields = JSON.parse(ret2.fieldJson);
												 
												// alert("fields:"+fields.length);
												 
												 for(let i=0;i<fields.length;i++)
												 {
													 
													 if(",id,batchId,createTime,name,userAvatarUrl,updateTime,appCode,userId,reportId,reportLevel,assistUserId,assistUserName,assistTreePath,source,".indexOf(","+fields[i].name+",")!=-1)
													 {
														 
													 }
													 else
													 {
														 //alert("删除："+fields[i].name);
														 fields.remove(fields[i]);
														 i--;
													 }
												 }
												 // alert("fields:"+fields.length);
												  let newFields=[];
												 let hasRequireField = this.findFormItems(components,formItems,newFields);
												 fields = fields.concat(newFields);
												//alert(fields.length+JSON.stringify(fields));
												 if(!hasRequireField)
												 {
													 // 看看有没有必填组件；
													  window.showErrorMessage("保存失败，请至少添加一个必填项组件！");
													 
													 this.sendEvent("saveFinish")
													 return false;
												 }
												 
												 
												 
												 
												 this.doRequest("/reportTemplate/updateInfo",(templateRet)=>{
												 	
												 	if(templateRet&&templateRet.success)
												 	{
												 		
												 		this.doRequest("/lingLongModel/save",(ret33)=>{
												 															 
												 															 if(ret33&&ret33.success)
												 															 {
																												 
																												 debugger;
												 															
												 																 // toSubmitPages.map((page,index)=>{
												 																 // 	console.log("---------------------");
												 																 // 	console.log(page);
												 																 	
												 																 // 	if(page.code=="list")
												 																 // 	{
												 																 // 		let components = page.keePage.components;
												 																 		
												 																 // 		components.map((item,index)=>{
												 																 // 			if(item.alias=='table0')
												 																 // 			{
												 																 // 				item.child=[];
												 																 // 				this.createNewCol(item,formItems,()=>{});
												 																 // 			}
												 																 // 		})
												 																 		
												 																 // 	}
												 																 	
												 																 // })
																												 
																												 // 这个地方有一个大的问题，原来一个表单有 formIndex和list两个页面，现在只返回了formIndex
																												 // 导致新版的保存不上，实际上list页面时没有用的
																												 
																												 
																												 
																												 	
																												 	this.removePageProperty(toSubmitPages)
																												 	this.doRequest("/keePage/saveAppPages", (ret)=> {
																												 		this.showMessage(ret);
																												 		
																												 		this.sendEvent("saveFinish");
																												 		if(ret.success == true) {
																												 			that.sendEvent("pageSaved");
																												 			that.state.newPageIds.splice(0, that.state.newPageIds.length);
																												 			that.loadKeePageList();
																												 		}
																												 	}, {
																												 		appPages: JSON.stringify(toSubmitPages),
																												 		appId: this.props.appid
																												 	});
																												 	
																												 	
																												 
																												 
												 															 }
												 															 else
												 															 {
												 																 window.showMessage(ret33);
												 																 this.sendEvent("saveFinish");
												 															 }
												 															
												 															 
												 		},{
												 															 fieldJson:JSON.stringify(fields),
												 															 id:ret2.id,
												 															 name:ret2.name,
												 		})
												 		
												 	}
												 			else
												 			{
												 				this.showErrorMessage(templateRet);
												 			}
												 			
												 		},{
												 			appCode: window.appName ,
												 			name:compName.cp.title,
												 			description:compDescription.cp.title,
												 			state:'ACTIVE',
												 		})	
														
														
														
												 
												 
												
												 
												 
												 });
										}
										});
										
							 
				 
				}
				else
				{
					this.removePageProperty(toSubmitPages);
					
					//1分钟后开启保存按钮，可重新保存
					this.pageSaveTimer = setTimeout(()=>{
						this.sendEvent("pageSaved");
					},60*1000);
				
					this.doRequest("/keePage/saveAppPages", (ret)=> {
						this.showMessage(ret);
						
						clearTimeout(this.pageSaveTimer);
						
						if(ret.success == true) {
							
							if(ret.map&&ret.map.app)
							{
								that.sendEvent("pageSaved",ret.map.app);
								window.appPages = this.state.appPages;
								let rows = ret.map.pages;
								if( rows ) { 
									  
										for(let i = 0; i <  rows.length; i++) {										
											let currentId =  rows[i].id;
											for(let j=0;j<this.state.appPages.length;j++)
											{
												if(this.state.appPages[j].keePage.id==currentId)
												{
													this.state.appPages[j].keePage.updateTime =  rows[i].updateTime;
												}
											}										 
										}
									 
									that.refresh(); 
								} 
							}
							else
							{
								that.sendEvent("pageSaved");
								if(!window.ServerConfig.websocketUrl)
								{
									//that.loadKeePageList();
									// 只更新页面的修改时间，解决页面的版本判断问题
									that.loadKeePageUpdateTime();
								}
							}
							
							//that.state.newPageIds.splice(0, that.state.newPageIds.length);
							
							// 需要刷新下本地的页面的updateTime
							// this.doRequest("/keePage/listData?search_EQ_appId="+window.appId+"&fields=id,updateTime",(ret2)=>{
								
							// 	console.log("刷新页面时间！")
							// 	if(ret2&&ret2.rows)
							// 	{
							// 		for(let i=0;i<ret2.rows.length;i++)
							// 		{
							// 			for(let j = 0; j < that.state.activePageList.length; j++) {
											
							// 				if(that.state.activePageList[j]&&that.state.activePageList[j].keePage&&that.state.activePageList[j].keePage.components)
							// 				{
							// 					if(ret2.rows[i].id==that.state.activePageList[j].keePage.id)
							// 					{
							// 						that.state.activePageList[j].keePage.updateTime=ret2.rows[i].updateTime;
							// 					} 
							// 				}
											
											
							// 		}
							// 	}
								
							// }});
							
							
							
							
							
							//that.loadKeePageList();
						}
						else
						{
							 
							if(window.$loading)
							{
								window.$loading.close();
							}
						}
					}, {
						appPages: window.Base64.encode(JSON.stringify(toSubmitPages)),
						appId: this.props.appid,
						"_base":1,
						"map.resFileList":(window.currentAppInfo.map.resFileList? window.Base64.encode( JSON.stringify(window.currentAppInfo.map.resFileList)):''),
						"map.appPageCss":(window.currentAppInfo.map.appPageCss?window.Base64.encode(window.currentAppInfo.map.appPageCss):''),
					});
				}
				
				
				
			}
			editApp=(appPage)=> {
				
				//需要判断是否有页面内容
				console.log("editAppPage");
				if(!appPage.keePage.pageXmlConfig&&!window.isReport)
				{
					this.doRequest("/keePage/getPageJson?id="+appPage.id,(ret)=>{
						
						//判断是redis里面的还是db返回的
						
						if(ret)
						{
							if(ret.keePage)
							{ 
								appPage.keePage = ret.keePage;
								appPage.code = ret.keePage.code;
								this.editApp(appPage);
								return ;
							}
							else
							{
								if(!ret.pageXmlConfig)
								{
									ret.pageXmlConfig="[]";
								}
								
								if(ret.pageXmlConfig)
								{
									appPage.keePage.pageXmlConfig = ret.pageXmlConfig;
									appPage.keePage.sqlTemplate = ret.sqlTemplate;
									
									let newAppPage = this.initKeePage(ret,this.state.formField);
									appPage.keePage = newAppPage.keePage;
									appPage.code = newAppPage.code;
									this.editApp(appPage);
									
									// 同步到redis缓存中
								//	this.sendEvent("changedComponents");
									
									return ;
								}
								
							}
							
							
						}
						else
						{
							 alert("加载页面失败！");
						}
						
					})
					
					return 
				}
				
				
				for(let i = 0; i < this.state.activePageList.length; i++) {
					if(this.state.activePageList[i].id == appPage.id) {
						this.state.activePageList[i].isSelected = true;
						this.state.initSelectPageCode = appPage.code;
						this.state.activePageList[i].keePage.isSelected = true;
					} else {
						this.state.activePageList[i].isSelected = false;
						this.state.activePageList[i].keePage.isSelected = false;
					}
				}
				appPage.keePage.edited = "1";
				// console.log(JSON.stringify(appPage));
				
				if(window.isReport)
				{
					if(appPage.keePage.code=='formIndex')
					{
						 
						this.doRequest("/reportTemplate/getByAppcode?appCode="+window.appName,(retTemplate)=>{
							
					 
						 
							// 修改下值，然后
							let compDescription = this.getComponentByAlias(appPage.keePage.components,"fsText002");
							let compName=this.getComponentByAlias(appPage.keePage.components,"fsText001");
							
							if(compDescription)
							{
								compDescription.cp.title = retTemplate.description; 
								compDescription.cp.maxLength=100;
							}
							
							if(compName)
							{
								compName.cp.title = retTemplate.name;
								compName.cp.maxLength=20;
							}
							this.sendEvent("right.changePage", appPage);
							this.refresh();
							
						 
						});
					}
				}
				else
				{
					this.sendEvent("right.changePage", appPage);
					this.refresh();
				}
				
				
			}
			
			createReportListPage=(cs)=>{
				
			}
			copy=(item)=> {
				console.log(item);
				//alert("copy");
				let that = this;
				this.doRequest("/keePage/get", (ret)=> {
					let newPage = JSON.parse(JSON.stringify(item));
					that.state.newPageIds.push(ret.id);
					newPage.id = ret.id;
					newPage.title = '页面' + (that.state.appPages.length + 1);
						newPage.isCanEdit = false;
					newPage.isDel = false;
					newPage.code = ret.id;
					newPage.keePage.id = ret.id;
					newPage.keePage.code = ret.id;
					newPage.keePage.title = newPage.title;
					that.state.activePageList.push(newPage);
					that.state.appPages.push(newPage);
					that.editApp(newPage); 
					this.sendSocketMsg("createNewPage",newPage); 
				});
			}
			move=(item)=> {
				let isNewPage = false;
				for(let i = 0; i < this.state.newPageIds.length; i++) {
					if(this.state.newPageIds[i] == item.id) {
						isNewPage = true;
						break;
					}
				}
				if(isNewPage == false) {
					this.openDlgPage("M::jdccApp/copyPages"  , {
					title: '批量复制页面到其他站点应用',
					size: '900',
					 
					top: "10vh",
					loadUrl: '/jdccApp/get?id=' ,
					extraParas: {
						fromPageId:item.id
					},
					onChanged(ret, form) {
						this.showMessage(ret);
							form.$emit("command", "close");
						}
					})
				} else {
					console.log("请先保存后再进行移动操作！");
				}
			}
			
			removeSocketAppPage=(item)=> {
				for(let i = 0; i < this.state.activePageList.length; i++) {
					if(this.state.activePageList[i].id == item.id) {
						if(i < this.state.activePageList.length - 1) {
							this.editApp(this.state.activePageList[i + 1]);
						} else {
							if(i > 0) {
								this.editApp(this.state.activePageList[i - 1]);
							} else {
								this.sendEvent("right.changePage", null);
							}
						}
						this.state.activePageList[i].keePage.isDel = true;
						this.state.activePageList[i].isDel = true;
						this.state.activePageList.remove(this.state.activePageList[i]);
						break;
					}
				} 
				
				this.refresh();
				
			}
			
			
			removeAppPage=(item)=> {
				for(let i = 0; i < this.state.activePageList.length; i++) {
					if(this.state.activePageList[i].id == item.id) {
						if(i < this.state.activePageList.length - 1) {
							this.editApp(this.state.activePageList[i + 1]);
						} else {
							if(i > 0) {
								this.editApp(this.state.activePageList[i - 1]);
							} else {
								this.sendEvent("right.changePage", null);
							}
						}
						item.keePage.isDel = true;
						item.isDel = true;
						this.state.activePageList.remove(item);
					}
				}
				
				//发送
				this.sendSocketMsg("removeAppPage",item);
				
			}
			
			sendSocketMsg=(actionName,item)=>{
				if(window.ServerConfig.websocketUrl&&window.appId)
				{
					let msgInfo = {
						action:actionName,
						appId:window.appId,
						fromEditor:window.editorInfo,
						item:item,
					}
					this.doRequest("/keePage/sendMessage?appId="+window.appId,(ret)=>{
						console.log("keePage/sendMessage"+ret);
					},{
						msgJson:JSON.stringify(msgInfo)
					})
				}
			}
			
			onMousedown=(event)=>{
				console.log("right:::mouse down page")
				 
				this.sendEvent("drag.select", event);
				this.sendEvent("showHuaBu");
			}
			onDrag=(obj)=>{
				console.log("right:::onDrag page....")
				let list = this.state.activePageList;
				for(let j = 0; j < list.length; j++) {
					if(list[j].id == obj.tid) {
						console.log("right:::drag.disableX....")
						this.sendEvent("drag.disableX");
						 
						// this.editApp(list[j]);
						 
						//this.editApp(list[j]);
						// list[j].isFloat = true;
						obj.callback(JSON.parse(JSON.stringify(list[j])));
						return;
					}
				}
			}
			onDraging=(obj)=> {
				// console.log("right::::::::::收到移动事件")
				let x = obj.x;
				let y = obj.y;
				let item = obj.item;
				let targetId = obj.targetId;
				let boxId = obj.boxId;
				
				//console.log("right::::::::::收到移动事件"+boxId+"  targetId="+targetId);
				
				if(!targetId)
				{
					return ;
				}
				
				if(item ) 
				{
					//console.log("right::::item:" + item.id)
				} 
				else
					return;
				let list = this.state.activePageList;
				for(let m = 0; m < 2; m++) {
					if(m == 0)
						list = this.state.activePageList;
					else
						list = this.state.appPages;
					if("fs-build-right-pages" == boxId) {
						
						//console.log("right::::::::::fs-build-right-pages");
						
						let exists = false;
						let oldIndex = -1;
						for(let j = 0; j < list.length; j++) {
							if(list[j].id == item.id ) {
								exists=true;
								list[j].isFloat = true;
							}
						}
						if(!exists)
						{
							continue;
						}
						for(let j = 0; j < list.length; j++) {
							if(list[j].id == item.id && targetId != item.id) {
								oldIndex = j;
								list.remove(list[j]);
								break;
							}
						}
						if(targetId ) {
							for(let j = 0; j < list.length; j++) {
								if(list[j].id == targetId) {
									if(targetId == item.id) {
										break;
									}
									if(oldIndex > j) {
										list.insert(j, item);
									} else {
										list.insert(j + 1, item);
									}
									break;
								}
							}
						} else {
							list.push(item);
						}
					}
					
					if(m == 0)
						 
						this.setState({activePageList:list});
					else
						 
						this.setState({appPages:list});
					
				}
				
			  
			}
			onDroped=(obj)=> {
				let that = this;
				let seq = 1;
				let list = this.state.activePageList;
				for(let j = 0; j < list.length; j++) {
					list[j].isFloat = false; 
					 
				}
				
				for(let j = 0; j < list.length; j++) {
					if(list[j].id==obj.pagenode)
					{
						this.editApp(list[j]);
					}
					 
				}
				
				
				this.setState({activePageList:list});
			}
			
			getNewPageCode=()=>{
				let pageCode = "page"+this.state.appPages.length;
				
				for(let num=this.state.appPages.length+1;num<1000;num++)
				{
					pageCode = "page"+num;
					let exists = false;
					for(let i=0;i<this.state.appPages.length;i++)
					{
						if(this.state.appPages[i].code==pageCode)
						{
							exists = true;
						}
					}
					if(!exists)
					{
						return num
					}
				}
				
				return "";
				
				
			}
			
			onSocketCreateNewPage=(newSocketPage)=>{
				this.state.activePageList.push(newSocketPage);
				newSocketPage.isSelected = false;
				this.state.appPages.push(newSocketPage); 
				this.refresh();
			}
			
			onCreateNewPageByPage=(pageId)=>{
			let that = this;
			
			let pageCode = this.getNewPageCode();
			
			if(!pageCode)
			{
				this.showErrorMessage("获取页面代号失败！");
				return ;
			}
			 
			this.doRequest("/keePage/get", (ret)=> {
				 // 页面代码需要改成 page+数字模式
				 
					if(pageId=="")
					{
						 
						that.state.newPageIds.push(ret.id);
						let newPage = that.initKeePage({
							id: ret.id,
							isDel: false,
							code: "page"+pageCode,
							title: '页面' + (pageCode),
							type: 'M',
							url: '',
							isCanEdit: false,
						}, that.state.formField);
						newPage.id = ret.id;
						newPage.keePage.pageXmlConfig = "{}";
						that.state.activePageList.push(newPage);
						that.state.appPages.push(newPage);
						that.editApp(newPage);
						that.refresh();
						
						this.sendSocketMsg("createNewPage",newPage); 
						
						if(window.isActivity)
						{
							setTimeout(()=>{
								this.sendEvent("changePageType","mobile");
							},100);
						}
						
						
					}
					else
					{
						 
						this.doRequest("/keePage/get?id="+pageId, (ret2)=> {
							that.state.newPageIds.push(ret.id);
							let newPage = that.initKeePage({
								id: ret.id,
								isDel: false,
								code: "page"+pageCode,
								title: '页面' + (pageCode),
								type: 'M',
								url: '',
								isCanEdit: false,
								pageXmlConfig:ret2.pageXmlConfig,
								sqlTemplate:ret2.sqlTemplate,
								config:ret2.config,
							}, that.state.formField);
							newPage.id = ret.id;
							that.state.activePageList.push(newPage);
							that.state.appPages.push(newPage);
							that.editApp(newPage);
							
							this.sendSocketMsg("createNewPage",newPage); 
							
							if(window.isActivity)
							{
								setTimeout(()=>{
									this.sendEvent("changePageType","mobile");
								},100);
							}
						});
					}
				});
			}
			createNewPage=()=> {
		  	let that = this;
			
		 	this.openDlgPage("M::jdccApp/crateFromTemplate"  , {
					title: '创建空白页或从模板页面创建',
					size: '800', 
					top: "10vh",
					loadUrl: '/jdccApp/get?id=' ,
					extraParas: {
					},
					onChanged(ret, form) {
					    that.onCreateNewPageByPage(ret.data.pageId);
							form.$emit("command", "close");
						}
					})
			}
			propFormFieldChange=(item, formData)=> {
				let that = this;
				this.sendEvent("propFormFieldChange");
				if(formData.name == 'fs-table-col') {
					setTimeout(()=> {
						that.updateActiveDivStyle();
					}, 50);
				}
			}
			
			
			setPageState=(keePage)=>{
				 
				 
					// 更新页面数据，然后让编辑区更新
					
					for(let i = 0; i < this.state.appPages.length; i++) {
						if(this.state.appPages[i].id == keePage.id) { 
							this.state.appPages[i].keePage = keePage;
							
						 
							if(!this.state.appPages[i].isDel)
							{
								this.editApp(this.state.appPages[i]);
							}
							break; 
						} 
					} 
					
					this.refresh();
					
				 
			}
			 
			
			changed=()=> {}
			valueChange=(item)=> {}
			
			// 返回一个系统字段，增加两个报表字段，做一个模板页面，这里面的都不能修改；
			getForm0=()=>{
				return {
					
						"style": {
							 
							"textAlign": "left",
							"height":"100%",
							"maxWidth":"800px",
							"display":"block",
							"width":"100%",
							"marginTop":"25px",
							"marginLeft":"auto",
							"marginRight":"auto",
							"padding":"0px",
						},
						"cp": {
							"dataBaseId": null,
							"tableId": null,
							"url": "/"+this.toHump(window.appName)+"/save",
							"field": null,
							"editable": true,
							"isAutoSubmit": null,
							"formLabelWidth": null,
							"labelPosition": "top",
							"canAdd": false,
							"maxNum": null,
							"alwaysShow": false
						},
						"alias": "form0",
						"value": "",
						"name": "fs-form",
						"isSystem":true,
						"isContainer": true,
						"id": ""+this.getRandString(),
						"title": "fs表单",
						"type": "layout",
						"isActive": true,
						"seq": "4",
						"isFloat": true,
						"child": [],
						"isAdding": true,
						"viewName": ""
					
				};
			}
			
			getTable0=()=>{
				return {
						"style": {
							"display": "block",
							"textAlign": "left"
						},
						"cp": {
							"dataBaseId": null,
							"tableId": null,
							"url": "/"+this.toHump(window.appName)+"/listData",
							"entityName": null,
							"isPager": true,
							"isHeader": true,
							"isCheckBox": false,
							"isAddOrDelBox": false,
							"isSn": true,
							"hasFixedField": false,
							"showType": "grid",
							"sortUrl": null,
							"field": null
						},
						"alias": "table0",
						"value": "",
						"name": "fs-table",
						"isContainer": true,
						"id": "rand72593733443755881799",
						"title": "fs表格",
						"type": "layout",
						"isActive": true,
						"seq": "5",
						"isFloat": true,
						"child": [],
						"isAdding": true,
						"viewName": "table0viewName"
					}
			}
			
			// 加载应用的所有页面
			loadKeePageUpdateTime=()=> { 
				 
				window.appPages = this.state.appPages; 
				let that = this;
				// 不返回页面详细信息
					//pageXmlConfig,sqlTemplate,
					let fields="code,title,updateTime"; 
					this.doRequest("/keePage/listData?" + "search_EQ_appId=" + this.props.appid +
					 "&order=asc&sort=seq&fields="+fields, (ret)=> { 
							 
							window.appPages = this.state.appPages;  
							if(ret.rows ) { 
								if(ret.rows ) {
									for(let i = 0; i < ret.rows.length; i++) {										
										let currentId = ret.rows[i].id;
										for(let j=0;j<this.state.appPages.length;j++)
										{
											if(this.state.appPages[j].keePage.id==currentId)
											{
												this.state.appPages[j].keePage.updateTime = ret.rows[i].updateTime;
											}
										}										 
									}
								} 
								that.refresh(); 
							} 
				});
			}
			
			
			// 加载应用的所有页面
			loadKeePageList=()=> {
				this.state.appPages = [];
				window.appPages = this.state.appPages;
				this.state.activePageList = [];
				let that = this;
				this.doRequest("/keeVueApp/getAppConfig?title=common-component-prop-form&name=form",  (formField)=>{
					that.state.formField = formField;
					let queryAppId = "";
					if(this.isNotBlank(this.props.appid)) {
						queryAppId = "search_EQ_appId=" + this.props.appid;
					} else {
						alert(404);
						return ;
						//window.location.href="/error/404.htm";
					}
					
					
						// 不返回页面详细信息
						//pageXmlConfig,sqlTemplate,
						let fields="code,title,type,url,config,isDel,updateTime"+",pageXmlConfig,sqlTemplate";
						if(window.ServerConfig.websocketUrl&&window.appId)
						{
							fields="code,title,type,url,config,isDel,updateTime";
						}
						 
						
						this.doRequest("/keePage/listData?" + queryAppId +
						 "&order=asc&sort=seq&fields="+fields, (ret)=> {
								
								
								this.state.appPages = [];
								window.appPages = this.state.appPages;
								this.state.activePageList = [];
								
								if(window.isReport)
								{
									this.doRequest("/reportTemplate/getByAppcode?appCode="+window.appName,(reportTemplate)=>{
									// is report app
									if(!ret.rows||ret.rows.length==0)
									{
										
										this.doRequest("/keePage/get", (data)=> {
											 
												if(data)
												{
													 
												
												//alert("add form");
													// 是一个空的应用，需要默认创建一个formIndex的表单页面
													let pid = "formIndex";
													that.state.newPageIds.push(pid);
													
													let form0=this.getForm0();
													
													let components = [];
													components.push({
							
								"style": {
									"display": "block",
									"textAlign": "left", 
									"minWidth":"30px",
									"fontWeight":"bold",
									"fontSize":"16px",
									"marginLeft":"16px",
									"marginRight":"16px",
									"marginTop":"16px",
									"color":"#000000"
								},
								"cp": {
									"title":''+reportTemplate.name,
									"maxLength":20,
								},
								"alias": "fsText001",
								"value": "",
								"name": "fs-text",
								"isContainer": false,
								"isSystem":true,
								"id": ""+this.getRandString(),
								"title": "文本",
								"type": "form",
								"isActive": true,
								"seq": "4",
								"isFloat": true,
								"child": [],
								"isAdding": true,
								"viewName": ""
							
						});
								components.push({
							
								"style": {
									"display": "block",
									"textAlign": "left", 
									"minWidth":"30px",
									"fontSize":"14px",
									"color":"#999999",
									
									"marginLeft":"16px",
									"marginRight":"16px",
									
									 
									"borderBottomWidth":"1px",
									"borderBottomStyle":"solid",
									"borderBottomColor":"#E8EBEC",
									 
								},
								"cp": {
									"title":''+reportTemplate.description,
									"maxLength":100,
								},
								"alias": "fsText002",
								"value": "",
								"name": "fs-text",
								"isContainer": false,
								"id": ""+this.getRandString(),
								"title": "文本",
								"type": "form",
								"isActive": true,
								"isSystem":true,
								"seq": "4",
								"isFloat": true,
								"child": [],
								"isAdding": true,
								"viewName": ""
							
						} );
													components.push(form0); 
													let newPage = that.initKeePage({
														id: data.id,
														isDel: false,
														code: pid,
														title: '表单',
														type: 'M',
														url: '',
														isCanEdit: false,
														keePage:{
															components:components
														}
													}, that.state.formField);
													
													newPage.keePage.components = components;
													newPage.id = pid;
													
													// 增加一个fs-form组件，并设置组件的高度为100%；设置表格组件的url信息
													// 以及设置一个提交按钮 
													that.state.activePageList.push(newPage);
													that.state.appPages.push(newPage);
													
													let table0 = this.getTable0();
													pid="list";
													let tablePage = that.initKeePage({
														id: data.id+"-2",
														isDel: false,
														code: pid,
														title: '列表',
														type: 'M',
														url: '',
														isCanEdit: false,
														keePage:{ }
													}, that.state.formField);
													let components2 = [{
																			"style": {
																				"display": "inline-block",
																				"textAlign": "left",
																				"verticalAlign": "top"
																			},
																			"cp": {
																				"title": "查询",
																				"field": null,
																				"buttonType": null,
																				"icon": null,
																				"type": "primary",
																				"size": "small",
																				"childFormAlias": null
																			},
																			"alias": "button0",
																			"value": "",
																			"name": "el-button",
																			"isContainer": false,
																			"id": "rand2654102283906464391",
																			"title": "按钮",
																			"type": "layout",
																			"isActive": true,
																			"seq": "0",
																			"isFloat": true,
																			"child": [],
																			"isAdding": true,
																			"viewName": "button0viewName"
																		}];
													components2.push(table0);
													tablePage.keePage.vueSource="/** 自定义方法,常用方法说明：this.getComponent(\"\")   CMap.xxxxx 获取某个组件对象 */ \n\n let crudExt = {\n\t\n\t\"on_button0.click\" : function(item,row){\n\t\t this.table0.query();\n\t},\n\t\t\n\n\t active:function(params){ \n\t\t this.activeFormPage(this,params);\n\t }\n  }\n\n\n ";
												
													tablePage.keePage.components = components2;
													tablePage.id = pid; 
												
													
													that.state.activePageList.push(tablePage);
													that.state.appPages.push(tablePage);
													
													that.editApp(newPage);
													// 创建list的页面  
													that.refresh();
													
													console.log(that.state.appPages);
													
													
												}
												else
												{
													console.log("获取新编号出错！")
												}
													
									});
									return;
									}
									else
									{
										// 已经有页面了，
										
									}
									});
								}
								
								
								if(ret.rows ) {
									let newPages = [];
									if(ret.rows ) {
										for(let i = 0; i < ret.rows.length; i++) {
											let t = that.initKeePage(ret.rows[i], formField);
											newPages.push(t);
											if(t.isDel != true) {
												that.state.activePageList.push(t);
											}
										}
									}
									that.state.appPages = newPages;
									window.appPages = newPages;
									
									window.activePageList = that.state.activePageList;
									
									if(that.state.activePageList.length > 0) {
										if(this.isNotBlank(that.state.initSelectPageCode)) {
											for(let i = 0; i < that.state.activePageList.length; i++) {
												if(that.state.activePageList[i].keePage.code == that.state.initSelectPageCode) {
													that.editApp(that.state.activePageList[i]);
													break;
												}
											}
										} else { 
											let pid = that.getUrlParameter("pid") 
											let hasDefault = false; 
											for(let i = 0; i < that.state.activePageList.length; i++) { 
												if((pid+"/").indexOf("/"+that.state.activePageList[i].keePage.code+"/")!=-1)
												{
													that.editApp(that.state.activePageList[i]);
													hasDefault = true;
													break;
												}
											} 
											if(!hasDefault)
											{
												that.editApp(that.state.activePageList[0]);
											} 
										}
									} 
									that.refresh(); 
								} 
					});
					
				});
			}
			initKeePage=(page, formField)=> {
				let that = this;
				let keePage = page;
				let componentJsonConfig = [];
				console.log("initKeePage");
				if(!this.isNotBlank(page.type)) {
					page.type = "M";
				}
				if(!this.isNotBlank(page.url)) {
					page.url = "";
				}
				page.background = "";
				if(page.pageXmlConfig ) {
					componentJsonConfig = JSON.parse(page.pageXmlConfig);
				}
				if(page.config ) {
					keePage.config = JSON.parse(page.config);
					if(!this.isNotBlank(keePage.config.pageType)) {
						keePage.config.pageType = "full";
						keePage.config.width = "1000px";
						keePage.config.height = "1200px";
					}
					if(keePage.config.pageType == "full") {
						if(keePage.config.width == null || (keePage.config.width + "").indexOf("px") == -1) {
							keePage.config.width = "1000px";
						}
						if(keePage.config.height == null || (keePage.config.height + "").indexOf("px") == -1) {
							keePage.config.height = "1200px";
						}
					}
					if(this.isNotBlank(keePage.config.code)) {
						keePage.code = keePage.config.code;
					}
					if(this.isNotBlank(keePage.config.background)) {
						keePage.background = keePage.config.background;
					}
				} else {
					keePage.config = {
						pageType: 'full',
						width: "1000px",
						height: "1200px",
					};
				}
				if(!this.isNotBlank(keePage.config.bgImg))
				{
					keePage.config.bgImg = "";
				}
				keePage.isDel = page.isDel;
				keePage.vueSource = keePage.sqlTemplate  ? keePage.sqlTemplate : window.sourceCodeStr;
				that.convertComponent(componentJsonConfig, formField);
				keePage.components = componentJsonConfig;
				keePage.isSelected = false;
				keePage.isCanEdit = false;
				
				keePage.edited = "0";
				
				//console.log("开始处理3：");
				let appPage = {
					id: keePage.id,
					keePage: keePage,
					code: keePage.code,
					isFloat: false,
					isSelected: false,
					isDel: page.isDel,
				}
				return appPage;
			}
			selectItem=(item)=> {
				if(item.targetUrl ) {}
			}

			renderItem=(item,index)=>{


				//console.log("渲染页面：渲染页面："+item.code);


				return <div  key={index}  style={{marginTop:'0px'}} >

							{
								item.isFloat===true?
								<div className={`jdcc-kee-page-item-grid-float`} v-if="item.isFloat==true" >
								</div>
								:

								<div style={{height:'75px'}}   className={`jdcc-pagename-item ${item.isSelected==true?'jdcc-pagename-item-active':'jdcc-pagename-item-hover'}`} onDoubleClick={()=>this.editAppPage(item)}
								onClick={()=>this.editApp(item)} >
								    <div style={{float:' left',cursor:' pointer', width:' 180px',paddingTop:' 3px'}} >
								        <div style={{float:' left'}} >
								            <i className={`fa fa-file-o`} >
								            </i>
								        </div>
								        <div style={{float:' left',marginLeft:'10px ',width:' 140px',overflow:'hidden',whiteSpace:'nowrap',textOverflow:' ellipsis'}} v-show="item.keePage.isCanEdit==false" >

												{item.keePage.title!=""?item.keePage.title :'&nbsp;'}

								        </div>
								    </div>
									
									 
								    <div className="page-code" style={{position:' absolute',fontSize:'12px',
									overflow:'hidden',top:'26px',left:' 33px',height:'24px',  right:' 8px',cursor:' pointer',textOverflow:' ellipsis'}} >

											{item.keePage.code}

								    </div>
								    <div className={`jdcc-pagename-item-btn`} style={{ cursor:' pointer',textAlign:'right',paddingRight:'5px'}} onClick={(e)=>{e.stopPropagation() }}   >
								        
								        <div style={{width:' 23px',display:' inline-block'}} >
								            <i className={`fa fa-clone  `} style={{}} onClick={(e)=>{  this.copy(item)}} title="复制页面" >
								            </i>
								        </div>
								        <div style={{width:' 23px',display:' inline-block'}} >
								            <i className={`el-icon-delete`} style={{fontSize:'16px'}} onClick={()=>this.removeAppPage(item)} title="删除页面" >
								            </i>
								        </div>
								    </div>
									  
									
									
								</div>

							}



                        </div>

			}

  render(){
  return(

<div className={`jdcc-disable-select`} id={this.state.randId} >
    <div style={{position:' absolute', top:' 0px', bottom:' 0', right:' 0', width:' 100%'}} >
        <div style={{position:' absolute',left:' 0',top:' 4px',right:' 0px',bottom:' 0px',overflow:' auto', padding:'8px'}} boxid="fs-build-right-pages" >
            <div >
                <div style={{width:' 100%'}} >
                    <div style={{padding:' 5px', textAlign:'right'}} >
                        <Button  size="small" shape="circle"  onClick={this.createNewPage} >
                       <i className="el-icon-plus"></i> 
                        </Button>
                        
                    </div>
					{ }
                   
                </div>
               
                <div style={{paddingLeft:'0px',marginTop:'15px'}} onMouseDown={this.onMousedown} >
                    <FsList list={this.state.activePageList} type="grid"   sortable={true} fixWidth={280} height={38} renderItem={this.renderItem}>

                    </FsList>
                </div>
            </div>
        </div>
    </div>
</div>
  );}
 }
